import type { FaireProductEntity } from "../../entity_types/product";

export const p_vhbmubd4kg: FaireProductEntity = {
  token: "p_vhbmubd4kg",
  type: "product",
  name: "Best Seller Nature Inspired Candle Assortment - Case of 12",
  brandName: "Little Mountain Home",
  imageUrl:
    "https://cdn.faire.com/fastly/1686715b74d10b7089643c78bf9a8d00b8483bff6a925f93f1500543d9bdaa21.jpeg",
  priceDollars: 13,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/891cabd516279f3c43cdf7594ed4504b3e8cb627d47602c2709b8a74bab6dd18.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
